import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { actionCreators as filterActionCreators } from "../../store/Filter"
import "./FilterChooser.scss"

export const FilterChooser = (props) => {
    const dispatch = useDispatch()
    const filter = useSelector(state => state.filter)
    const custom = props?.custom || null
    const mini = props?.mini
    const disabled = props?.disabled
    const datasetId = props?.datasetId
    const style = props?.style
    const showN = props?.showN || false
	
    const selectedFilter = datasetId ? filter.selected[datasetId] : filter.selectedFilter

    // Threshold for styling
    const threshold = 50
    const isBelowThreshold = selectedFilter?.n !== null && selectedFilter?.n < threshold

    // console.log("FilterChooser SELECTEDFILTER", selectedFilter)

    return (
		<div className={`filter-chooser${mini ? " mini" : ""}${disabled ? " disabled" : ""}`} style={style}>
			{true || hideWave ? null : (
					<div
						className={"wave-cell " + (disabled ? " disabled" : "")}>
						<i className="fal fa-calendar-alt glyph" />
						<span className="label">Q1 2019–Q1 2020</span>
					</div>
				)}
            <div className={"filter-cell text-truncate " + (disabled ? " disabled" : "") + (true || hideWave ? " nosep" : "")}
                onClick={() => {
                    if (!disabled) {
                        window.topBar.openMenu("filter", { datasetId, custom })
                    }
                }}
                title={selectedFilter?.label}
            >
                <i className="fal fa-filter glyph" />
                <span className="label">{selectedFilter?.autoLabel || "Error: Filter Not Set"}</span>
            </div>

            {selectedFilter?.n !== undefined && showN ? (
                <div className={`sample-cell ${isBelowThreshold ? "low-sample" : ""}`}>
                    <i className="fal fa-male xglyph" />
                    <span className="label">{selectedFilter.n !== null ? selectedFilter.n : "..."}</span>
                </div>
            ) : null}
        </div>
    )
}
